<footer>
  <div class="main-footer-content">
  <div class="logo">
  <img
    src="assets/images/regione-veneto-footer.png"
    alt="logo della regione veneto"
  />
  </div>

  <div class="info">
    <div class="contatti">
      <p>Contatti</p>
      <hr />
      <p>
        © Regione del Veneto - Giunta Regionale<br />
        Palazzo Balbi - Dorsoduro, 3901<br />
        30123 Venezia<br />
        P.Iva: 02392630279
      </p>
    </div>
    <div class="recapiti">
      <div class="upper">
        <p>Recapiti</p>
        <hr />
        <p>
          Centralino: 041 27 92 111 <br />
            <a href="mailto:area.sanitasociale@pec.regione.veneto.it ">PEC della Regione del Veneto</a><br />
        </p>
      </div>
      <div class="lower">
        <p>Pagine utili</p>
        <hr />
        <p>
          <a href="https://www.regione.veneto.it/direzione-prevenzione-sicurezza-alimentare-veterinaria" target="_blank" rel="noopener">Link Utili</a> <br />
        </p>
      </div>
    </div>
    <div class="social">
      <p>Seguici su</p>
      <hr />
      <div class="socials-logos">
        <a target="_blank" rel="noopener" class="pi pi-facebook" href="http://www.facebook.com/RegionedelVeneto"></a>
        <a target="_blank" rel="noopener" class="pi pi-instagram" href="https://www.instagram.com/regioneveneto/"></a>
        <a target="_blank" rel="noopener" class="pi pi-twitter" href="https://x.com/RegioneVeneto"></a>
        <a target="_blank" rel="noopener" class="pi pi-youtube" href="https://www.youtube.com/channel/UCkivR_pa1yxtS-G69mrctQQ"></a>
        <a target="_blank" rel="noopener" class="pi pi-vimeo" href="http://vimeo.com/user3836211"></a>
      </div>
    </div>
  </div>

</div>
<div class="thin-footer-content">


    <a href="https://www.regione.veneto.it/web/guest/accessibilita" rel="noopener" target="_blank">Accessibilità</a>
    <a href="https://www.regione.veneto.it/web/guest/privacy" rel="noopener" target="_blank">Privacy Policy</a>
    <a href="https://www.regione.veneto.it/web/guest/informativa-cookies" rel="noopener" target="_blank">Informativa Cookies</a>
    

</div>
</footer>

